// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"100":"59541227","154":"4baefb81","228":"f6ae891b","433":"32c0c085","451":"efc14cec","729":"4eea9d26","754":"b5a4d117","801":"879d0f48"}[chunkId] + ".chunk.js";
};